import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  benefitsSectionContent,
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionContent,
  tipsSectionContent,
  whyChooseSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/gear-storage-fee-page'

interface GearStorageFeePageProps {}

const GearStorageFeePage: React.FC<GearStorageFeePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
            w-[324px] h-[218px] 
            md-mn:w-[380px] md-mn:h-[286px] 
            lg:!w-[448px] lg:!h-[313px] 
            xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[311px] xl-min:!h-[50px] w-[266px] h-[44px]'
        className='
            xl-min:[&>div:first-child]:!max-w-[760px] 
            xl-min:[&_p]:!w-[80%]
            xl-min:[&_p]:!ml-0
            [&_p]:max-w-[95%]
            [&_p]:text-pretty
            lg-mn:[&>div:first-child]:max-w-[436px]
            lg-mn:[&_h1]:w-full
            md-mn:[&_h1]:w-[80%]
            [&_h1]:w-[90%]
        '
      />
      <WhyWeSection isBgDark {...whyWeSectionContent} className='xl-min:[&_button]:!w-[311px] [&_button]:w-[254px]' />
      <HelperSection
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
        sectionTitleClassName='md-mn:w-full w-[90%]'
      />
      <ServiceTipsSectionSection
        isBgDark
        {...serviceTipsSectionContent}
        className={`
          [&>div>div:nth-of-type(2)]:md-mn:grid-cols-3
          [&_article]:text-center
          [&_article_div]:w-full
          md-mn:[&_article]:px-0 
          [&_article]:px-6
          [&_p]:mx-auto
          xl-min:[&_button]:!w-[311px] 
          [&_button]:w-[274px] 
          `}
        sectionTitleClassName='w-full md-mn:[&_p]:w-full [&_p]:w-[90%]'
      />
      <HelperSection
        {...whyChooseSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
        className={`
            [&_ul]:w-full
            lg-mn:[&>div>div:last-of-type>div]:!flex-row
            xl-min:[&>div>div:last-of-type>div]:!gap-1
            [&>div>div:last-of-type>div]:flex-col
            [&_.content-container]:!mb-3
            `}
      />
      <ServiceTipsSectionSection isBgDark {...tipsSectionContent} />
      <HelperSection
        {...benefitsSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
        className={`
            [&_ul]:w-full
            lg-mn:[&>div>div:last-of-type>div]:!flex-row-reverse
            xl-min:[&>div>div:last-of-type>div]:!gap-1
            [&>div>div:last-of-type>div]:flex-col
            [&_.content-container]:!mb-3
            `}
        sectionTitleClassName='w-full'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
          md-mn:[&_h3]:w-full
          [&_h3]:w-[90%]
          xl-min:[&_button]:!w-[281px]
          [&_button]:w-[280px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default GearStorageFeePage
